import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { api_rbac_user_roles } from '../../constants/apiRoutes';

// ------------------------------------
// Constants
// ------------------------------------

const SET_USER_ROLES = 'SET_USER_ROLES';

const initialState = [];

// ------------------------------------
// Actions
// ------------------------------------
const setUserRoles = createAction(SET_USER_ROLES);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_USER_ROLES]: (state, { payload }) => {
    return payload;
  },
};

export const getUserRoles = (dispatch, userId) =>
  http.get(api_rbac_user_roles(userId)).then(({ data }) => {
    dispatch(setUserRoles(data));
    return data;
  });

export const updateUserRoles = (dispatch, userId, roles) =>
  http
    .put(api_rbac_user_roles(userId), roles)
    .then(({ data }) => dispatch(setUserRoles(data)));

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearUserRoles = () => setUserRoles(initialState);
